export default __webpack_public_path__ + "assets/svg/logo.a55b1e19.svg";